import { useClientPortalAPI } from "@certn/api";

/**
 * Billing profile item returned from the billing-profiles-compact endpoint
 */
interface UseBillingProfilesCompactParams extends Record<string, unknown> {
  archived?: string;
  ordering?: string;
}

/**
 * Hook to fetch billing profiles compact list.
 * Returns an array of billing profiles.
 */
export function useBillingProfilesCompact(
  clientId: string | null | undefined,
  params?: UseBillingProfilesCompactParams
) {
  const { data, isLoading, error, mutate } = useClientPortalAPI(
    clientId
      ? `/api/internal/client-portal/customer-accounts/${clientId}/billing-profiles-compact/`
      : null,
    params
  );

  return {
    data: data ?? [],
    isLoading,
    error,
    mutate,
  };
}
